var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label
      ? _c("label", { staticClass: "font-size-12" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _c("div", { staticClass: "input-container d-flex" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.iValue,
            expression: "iValue",
          },
        ],
        staticClass: "form-control",
        style: { flex: "1 1 auto" },
        attrs: { type: "text", placeholder: "https://example.com" },
        domProps: { value: _vm.iValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.iValue = $event.target.value
          },
        },
      }),
      _c(
        "button",
        {
          staticClass: "btn-upload btn-remove",
          attrs: { title: "Delete" },
          on: { click: _vm.removeVideo },
        },
        [_c("i", { class: _vm.deleteIcon })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }